import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        baseApi: "https://cake.duub.xyz",
    },
    getters: {},
    mutations: {},
    actions: {},
    modules: {}
})
